import { render, staticRenderFns } from "./singleBlog.vue?vue&type=template&id=e5ac5c5c&scoped=true&"
import script from "./singleBlog.vue?vue&type=script&lang=js&"
export * from "./singleBlog.vue?vue&type=script&lang=js&"
import style0 from "./singleBlog.vue?vue&type=style&index=0&id=e5ac5c5c&lang=scss&scoped=true&"
import style1 from "./singleBlog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ac5c5c",
  null
  
)

export default component.exports